import { RegistrationStrings, WaitlistStrings } from '../../constants';

import AdvertisementModule from './advertisement/AdvertisementModule';
import AnnouncementModule from './announcement/AnnouncementModule';
import CategoryModule from './categories/CategoryModule';
import CommentModule from './comments/CommentModule';
import FeaturedBannerModule from './featured-banner/FeaturedBannerModule';
import PostRequestOverrideModule from './post-request-override/PostRequestOverrideModule';
import PostModule from './posts/PostModule';
import RegistrationModule from './registration/RegistrationModule';
import SubCategoryModule from './sub-categories/SubCategoryModule';
import SuggestedCategoriesModule from './suggested-categories/SuggestedCategoriesModule';
import SuggestedSubCategoriesModule from './suggested-sub-categories/SuggestedSubCategoriesModule';
import TopicModule from './topics/TopicModule';
import UserModule from './users/UserModule';
import WaitlistModule from './waitlist/WaitlistModule';

export type RouteDefintion = {
  icon?: JSX.Element | null;
  name: string;
  path: string;
  component: () => JSX.Element;
  children?: RouteDefintion[];
};

export const CMSRouteSections: RouteDefintion[] = [
  { icon: null, name: WaitlistStrings.TITLE, path: 'waitlist', component: WaitlistModule },
  {
    icon: null,
    name: RegistrationStrings.TITLE,
    path: 'registration',
    component: RegistrationModule,
  },
  {
    icon: null,
    name: 'Users',
    path: 'users',
    component: UserModule,
  },
  {
    icon: null,
    name: 'Featured Banner',
    path: 'featured-banner',
    component: FeaturedBannerModule,
  },
  {
    icon: null,
    name: 'Advertisements',
    path: 'advertisements',
    component: AdvertisementModule,
  },
  {
    icon: null,
    name: 'Announcements',
    path: 'announcements',
    component: AnnouncementModule,
  },
  {
    icon: null,
    name: 'Categories',
    path: 'categories',
    component: CategoryModule,
    children: [
      {
        icon: null,
        name: 'Suggested category',
        path: 'suggested-categories',
        component: SuggestedCategoriesModule,
      },
    ],
  },
  {
    icon: null,
    name: 'Sub-Categories',
    path: 'sub-categories',
    component: SubCategoryModule,
    children: [
      {
        icon: null,
        name: 'Suggested sub categories',
        path: 'suggested-sub-categories',
        component: SuggestedSubCategoriesModule,
      },
    ],
  },
  {
    icon: null,
    name: 'Topics',
    path: 'topics',
    component: TopicModule,
  },
  {
    icon: null,
    name: 'Articles',
    path: 'posts',
    component: PostModule,
    children: [
      {
        icon: null,
        name: 'Request Overrides',
        path: 'request-overrides',
        component: PostRequestOverrideModule,
      },
    ],
  },
  {
    icon: null,
    name: 'Comments',
    path: 'reported-comments',
    component: CommentModule,
  },
];

export default CMSRouteSections;
